import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { FetchUserCourseCertificates, FetchUserCourseCertificatesSuccess } from '../../actions';
import { CertificateRecord } from '../../models/certificate-record';

export class UserCourseCertificatesDataSource implements DataSource<CertificateRecord> {
    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredCertificates$: Observable<CertificateRecord[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<CertificateRecord[]> {
        return this._filteredCertificates$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadCertificates(pageSize?: number, pageNumber?: number, search?: string, userId?: string, sortBy?: string, sortOrder?: string): void {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchUserCourseCertificates({
                pageSize,
                pageNumber,
                search,
                userId,
                sortBy,
                sortOrder,
            })
        );

        this._action$
            .pipe(
                ofActionDispatched(FetchUserCourseCertificatesSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
